document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('ftContactForm');
    if (!form) return;

    var reasonEl = document.getElementById('reason');
    var csTopicRow = document.getElementById('customerServiceTopicRow');
    var orderNumberRow = document.getElementById('orderNumberRow');
    var wearTestSection = document.getElementById('wearTestSection');
    var submitBtn = document.getElementById('ftSubmitButton');

    function formatUSDateTime(d) {
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear();
        var hours = d.getHours();
        var mins = d.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        var h12 = hours % 12;
        if (h12 === 0) h12 = 12;
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        if (mins < 10) mins = '0' + mins;
        return month + '/' + day + '/' + year + ' ' + h12 + ':' + mins + ' ' + ampm;
    }

    function buildDeskSubject() {
        var reason = reasonEl.value;
        var classification = document.getElementById('classification').value.trim();
        var firstName = document.getElementById('firstName').value.trim();
        var lastName = document.getElementById('lastName').value.trim();
        var base = classification || reason || '';
        var dt = formatUSDateTime(new Date());
        return base + ' - ' + firstName + ' ' + lastName + ' - ' + dt;
    }

    function showError(field, msg) {
        clearError(field);
        var el = document.createElement('div');
        el.className = 'ft-field-error';
        el.textContent = msg;
        field.parentNode.appendChild(el);
        field.classList.add('ft-input-error');
        field.focus();
    }

    function clearError(field) {
        var parent = field.parentNode;
        var existing = parent.querySelector('.ft-field-error');
        if (existing) parent.removeChild(existing);
        field.classList.remove('ft-input-error');
    }

    function clearAllErrors() {
        var errors = form.querySelectorAll('.ft-field-error');
        for (var i = 0; i < errors.length; i++) {
            errors[i].parentNode.removeChild(errors[i]);
        }
        var highlighted = form.querySelectorAll('.ft-input-error');
        for (var j = 0; j < highlighted.length; j++) {
            highlighted[j].classList.remove('ft-input-error');
        }
    }

    function validateForm(system) {
        clearAllErrors();

        var firstName = document.getElementById('firstName');
        var lastName = document.getElementById('lastName');
        var email = document.getElementById('email');
        var reason = reasonEl;
        var message = document.getElementById('message');
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

        if (!firstName.value.trim()) {
            showError(firstName, 'First Name is required.');
            return false;
        }
        if (!lastName.value.trim()) {
            showError(lastName, 'Last Name is required.');
            return false;
        }
        if (!email.value.trim()) {
            showError(email, 'Email is required.');
            return false;
        }
        if (!emailPattern.test(email.value.trim())) {
            showError(email, 'Please enter a valid email address.');
            return false;
        }
        if (!reason.value) {
            showError(reason, 'Please select a reason.');
            return false;
        }
        if (!message.value.trim()) {
            showError(message, 'Message is required.');
            return false;
        }

        if (system === 'crm') {
            var wearRequiredFields = form.querySelectorAll('[data-wear-required="true"]');
            for (var i = 0; i < wearRequiredFields.length; i++) {
                var f = wearRequiredFields[i];
                if (!f.value.trim()) {
                    var labelEl = f.closest('.q') ? f.closest('.q').querySelector('.question') : null;
                    var labelText = labelEl ? labelEl.textContent.replace('*', '').trim() : 'This field';
                    showError(f, labelText + ' is required for Wear Test submissions.');
                    return false;
                }
            }
        }

        var classification = document.getElementById('classification').value.trim();
        var orderInput = document.getElementById('orderNumber');
        if (orderInput) {
            var needsOrder =
                reasonEl.value === 'Customer Service' &&
                (classification === 'Order Status' ||
                    classification === 'Return' ||
                    classification === 'Order Modification');

            if (needsOrder && !orderInput.value.trim()) {
                showError(orderInput, 'Order Number is required for this selection.');
                return false;
            }
        }

        return true;
    }

    function setSystemHiddenFields(system) {
        var hiddenInputs = form.querySelectorAll('input[type="hidden"][data-system]');
        for (var i = 0; i < hiddenInputs.length; i++) {
            var sys = hiddenInputs[i].getAttribute('data-system');
            hiddenInputs[i].disabled = (sys !== system);
        }
    }

    function updateOrderNumberVisibility() {
        if (!orderNumberRow) return;
        var reason = reasonEl.value;
        var classification = document.getElementById('classification').value;
        var needsOrder =
            reason === 'Customer Service' &&
            (classification === 'Order Status' ||
                classification === 'Return' ||
                classification === 'Order Modification');

        orderNumberRow.style.display = needsOrder ? 'block' : 'none';
    }

    function toggleSections() {
        var reason = reasonEl.value;

        // Customer Service Topic visibility
        if (reason === 'Customer Service') {
            csTopicRow.style.display = 'block';
        } else {
            csTopicRow.style.display = 'none';
            var cls = document.getElementById('classification');
            if (cls) cls.value = '';
        }

        // Wear Test section visibility
        if (reason === 'Wear Test') {
            wearTestSection.style.display = 'block';
        } else {
            wearTestSection.style.display = 'none';
        }

        updateOrderNumberVisibility();
    }

    // Event wiring
    if (reasonEl) {
        reasonEl.addEventListener('change', toggleSections);
    }

    var classEl = document.getElementById('classification');
    if (classEl) {
        classEl.addEventListener('change', updateOrderNumberVisibility);
    }

    // Initial state
    toggleSections();

    form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (submitBtn) submitBtn.disabled = true;

        var reason = reasonEl.value;
        var system = (reason === 'Wear Test') ? 'crm' : 'desk';

        if (!validateForm(system)) {
            if (submitBtn) submitBtn.disabled = false;
            return;
        }

        if (system === 'crm') {
            form.action = 'https://crm.zoho.com/crm/WebToLeadForm';
        } else {
            form.action = 'https://desk.zoho.com/support/WebToCase';
        }

        setSystemHiddenFields(system);

        if (system === 'desk') {
            var lastNameVal = document.getElementById('lastName').value.trim();
            var deskContactName = document.getElementById('deskContactName');
            if (deskContactName) {
                deskContactName.value = lastNameVal;
            }
            var subj = buildDeskSubject();
            var deskSubject = document.getElementById('deskSubject');
            if (deskSubject) {
                deskSubject.value = subj;
            }
        }

        form.submit();
    });
});
